import { render, staticRenderFns } from "./petcategory.vue?vue&type=template&id=0f74a186&"
import script from "./petcategory.vue?vue&type=script&lang=js&"
export * from "./petcategory.vue?vue&type=script&lang=js&"
import style1 from "../category/category.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports